// features/cart/components/cart-button.tsx
"use client"

import * as React from "react"
import { useParams } from "next/navigation"

import { useAuthStore } from "@/lib/store/auth-store"
import { useCartDetail } from "@/features/cart/hooks/use-cart-detail"
import { Button } from "@/components/ui/button"
import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"
import { Icons } from "@/components/icons"

import { CartContent } from "./cart-content" // Import the content component

export function CartButton() {
  // Note: Item count badge logic is omitted for simplicity for now.
  // It would typically involve fetching cart data here or subscribing to a global state.
  const restaurantId = useParams().id

  const { isAuthenticated } = useAuthStore()

  const { data: cartResponse } = useCartDetail()

  const badgeNum = React.useMemo(() => {
    if (restaurantId) {
      // Number of item in cart
      const selectedCart = cartResponse?.carts.find(
        (cart) => cart.restaurant_id === Number(restaurantId)
      )

      return (
        selectedCart?.restaurant_items.reduce(
          (sum, item) => sum + item.quantity,
          0
        ) || 0
      )
    } else {
      return cartResponse?.carts.length || 0
    }
  }, [cartResponse, restaurantId])

  if (!isAuthenticated) {
    return null
  }

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          aria-label="Open cart"
          className="size-11 rounded-full relative shrink-0"
        >
          <Icons.cart className="size-5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />
          {badgeNum >= 0 && (
            <div className="absolute top-0 right-0">
              <div className="size-5 relative rounded-full bg-red-700 text-white flex items-center justify-center">
                <span className="text-xs absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-semibold">
                  {badgeNum}
                </span>
              </div>
            </div>
          )}
        </Button>
      </SheetTrigger>
      {/* Set side="right" explicitly, adjust width, remove padding (p-0), make flex column */}

      <SheetTitle className="sr-only">Giỏ hàng của tôi</SheetTitle>
      <SheetContent
        side="right"
        className="w-[90vw] max-w-md sm:max-w-md md:max-w-lg p-0 flex flex-col"
      >
        <CartContent restaurantId={Number(restaurantId)} />
      </SheetContent>
    </Sheet>
  )
}
